import {Checkbox} from '@/components/commons/checkbox/ChekBox'
import {FormFieldBox} from '@/components/ui/form-atoms/FormAtoms'
import {useTranslation} from '@/translations/i18n'

export const OperatorSignatureField = ({
    isSigned,
    setIsSigned
}: {
    isSigned: boolean
    setIsSigned: (isSigned: boolean) => void
}) => {
    const {t} = useTranslation()
    return (
        <FormFieldBox fitContent isSelected={isSigned}>
            <Checkbox
                id="sign-check"
                checked={isSigned}
                label={t('commons:operators_signature')}
                onChange={() => setIsSigned(!isSigned)}
            />
        </FormFieldBox>
    )
}
